import React from 'react';
import { Leaf, Users, Award } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const SustainabilitySection = () => {
  const { language } = useLanguage();

  const sustainabilityData = {
    tr: {
      title: 'Sürdürülebilirlik',
      subtitle: 'Çevre ve toplum için sürdürülebilir lojistik çözümleri sunuyoruz.',
      items: [
        {
          id: 1,
          icon: 'Leaf',
          title: 'Çevre Dostu Yaklaşım',
          description: 'Karbon emisyonunu azaltmak için modern ve çevre dostu araç filosu kullanıyoruz.'
        },
        {
          id: 2,
          icon: 'Users',
          title: 'Toplumsal Sorumluluk',
          description: 'Yerel toplulukları destekliyor ve sosyal sorumluluk projelerine katkı sağlıyoruz.'
        },
        {
          id: 3,
          icon: 'Award',
          title: 'Kalite Standartları',
          description: 'Uluslararası kalite ve çevre yönetim sistemleri sertifikalarına sahibiz.'
        }
      ]
    },
    en: {
      title: 'Sustainability',
      subtitle: 'We provide sustainable logistics solutions for the environment and society.',
      items: [
        {
          id: 1,
          icon: 'Leaf',
          title: 'Eco-Friendly Approach',
          description: 'We use modern and environmentally friendly fleet to reduce carbon emissions.'
        },
        {
          id: 2,
          icon: 'Users',
          title: 'Social Responsibility',
          description: 'We support local communities and contribute to social responsibility projects.'
        },
        {
          id: 3,
          icon: 'Award',
          title: 'Quality Standards',
          description: 'We hold international quality and environmental management system certificates.'
        }
      ]
    }
  };

  const iconMap = { Leaf, Users, Award };
  const content = sustainabilityData[language];

  return (
    <section id="sustainability" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#36344D] mb-4">
            {content.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {content.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {content.items.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="bg-white rounded-lg p-8 shadow-md hover:shadow-xl transition-all duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
                    <IconComponent className="w-10 h-10 text-green-600" />
                  </div>
                  <h3 className="text-2xl font-bold text-[#36344D] mb-4">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SustainabilitySection;